var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramInsights40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C11.6421346,15 15,11.6421346 15,7.5 C15,3.35786538 11.6421346,0 7.5,0 C3.35786538,0 0,3.35786538 0,7.5 C0,11.6421346 3.35786538,15 7.5,15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insights40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 8,
    y: 11.5,
    width: 17,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 8,
    y: 18,
    width: 17,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 8,
    y: 24.5,
    width: 15,
    height: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(14.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 13.5,
    x2: 17.5,
    y2: 18.5,
    id: "Stroke-1",
    stroke: "#4F4C4D",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFCC00",
    mask: "url(#mask-2)",
    points: "-0.615384615 -1.69230769 18.7692308 -1.69230769 18.7692308 17.6923077 -0.615384615 17.6923077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C11.6421346,15 15,11.6421346 15,7.5 C15,3.35786423 11.6421346,0 7.5,0 C3.35786423,0 0,3.35786423 0,7.5 C0,11.6421346 3.35786423,15 7.5,15 Z",
    id: "Stroke-5"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramInsights40);
export default __webpack_public_path__ + "static/media/pictogramInsights40.a048636c0225aebb985d6c326b99e14f.svg";
export { ForwardRef as ReactComponent };